import { useAskInputSearchModes } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/hooks/useAskInputSearchModes.js';
import { useAskInputActions } from '#pplx/frontend/apps/ask/ask-input/ask-input-provider/components/AskInputProviderShared.js';
import { useAskInputModelCouncilUrlIntent, useAskInputModelSelectorUrlIntent, useAskInputWindowsVoiceUrlIntents, } from '#pplx/frontend/apps/ask/ask-input/multimodal-url-intents/useAskInputUrlIntents.js';
import { noop } from 'lodash-es';
export function useComposerUrlIntents({ isModeReady, omittedSearchModes, onSearchModeSelected, windowsVoiceIntents, }) {
    const { onActiveMenuChange } = useAskInputActions();
    const { searchModeControllerProps } = useAskInputSearchModes({
        enabled: isModeReady,
        isFollowUp: false,
        omittedSearchModes,
        onSearchModeSelected,
    });
    // Preserve the entry order when Council, voice, and model-menu intents coexist.
    useAskInputModelCouncilUrlIntent(searchModeControllerProps);
    useAskInputWindowsVoiceUrlIntents({
        isWindowsApp: windowsVoiceIntents?.isWindowsApp ?? false,
        onStartDictation: windowsVoiceIntents?.onStartDictation,
        onOpenVoiceToVoice: windowsVoiceIntents?.onOpenVoiceToVoice ?? noop,
    });
    useAskInputModelSelectorUrlIntent(onActiveMenuChange);
}
//# sourceMappingURL=useComposerUrlIntents.js.map